import React, { useMemo } from 'react';
import PlotlyComponent from 'react-plotly.js';
import guid from '../../../utils/Guid';
import styles from './Chart.module.scss';

const Plot = PlotlyComponent as any;

interface IMultipleLineSeriesProps {
  data: Array<Array<{ Time: string; Value: number }>>;
  names: string[];
  colors: string[];
  variable: string;
  title?: string;
}

const MultipleLineSeries: React.FC<IMultipleLineSeriesProps> = ({
  data,
  names,
  colors,
  variable,
  title,
}) => {
  const GUID = useMemo(() => guid(), []);

  const chartData = useMemo(() => {
    const formattedData = data.map((seriesData, index) => ({
      x: seriesData.map((d) => d.Time),
      y: seriesData.map((d) => d.Value),
      type: 'scatter' as const,
      mode: 'lines' as const,
      name: names[index],
      line: { color: colors[index] },
    }));
    return formattedData;
  }, [data, names, colors]);

  return (
    <div
      className={styles.root}
      id={GUID}
      data-testid='Validation-Timeseries-chart'
    >
      <Plot
        id='Validation-in-situ-Timeseries-chart'
        data={chartData}
        layout={{
          title: title ?? 'Insitu Timeseries',
          xaxis: { title: 'Time' },
          yaxis: { title: variable },
        }}
        config={{
          displaylogo: false,
          toImageButtonOptions: {
            filename: `Insitu_Validation_${names[0]}_${names[1]}_${
              new Date().toISOString().split('T')[0]
            }`,
          },
        }}
        useResizeHandler={true}
        style={{ width: '100%', height: '100%' }}
        className={styles.plot}
      />
    </div>
  );
};

export default React.memo(MultipleLineSeries);
